'use client';

import jsPDF from 'jspdf';
import { useState } from 'react';

import { capitalize } from './capitalize';
import dayjs from 'dayjs';
import { formatCurrency } from './formatCurrency';

import { Button } from '@chakra-ui/react';

function Boletin({ student, dataResults, grade, loadingData, extraNames = new Set(), year = String(new Date().getFullYear()), enrollmentStatus }) {
  const [loading, setLoading] = useState(false);

  const simplificaciones = {
    'Cédula de Ciudadanía': 'CC',
    'Cédula de Extranjería': 'CE',
    'Licencia de conducir': 'LC',
    Pasaporte: 'PP',
    'Permiso especial de permanencia': 'PEP',
    'Registro civil': 'RC',
    'Tarjeta de Identidad': 'TI',
    'Permiso por protección temporal': 'PPT',
  };

  const typeDoc = simplificaciones[student?.identity_type?.name];


  const loadImage = (src) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = (e) => reject(e);
      img.src = src;
    });


  const generarCertificadoViejo = async () => {
    if (!student) {
      console.error('No se recibió student');
      return;
    }

    try {
      const sinGrado = grade.replace(/grado:\s*|\s*\(.*?\)/gi, '');
      const soloText = sinGrado.split(' ')[0];
      const gradeText = capitalize(soloText);

      const promovido = {
        Primero: 'Segundo',
        Segundo: 'Tercero',
        Tercero: 'Cuarto',
        Cuarto: 'Quinto',
        Quinto: 'Sexto',
        Sexto: 'Séptimo',
        Séptimo: 'Octavo',
        Octavo: 'Noveno',
        Noveno: 'Décimo',
        Décimo: 'Undécimo',
        Decimo: 'Undécimo',
        Once: 'Graduado',
        Undécimo: 'Graduado',
        Undecimo: 'Graduado',
      };

      const gradeNumber = {
        Primero: '1',
        Segundo: '2',
        Tercero: '3',
        Cuarto: '4',
        Quinto: '5',
        Sexto: '6',
        Séptimo: '7',
        Octavo: '8',
        Noveno: '9',
        Décimo: '10',
        Decimo: '10',
        Once: '11',
        Undécimo: '11',
        Undecimo: '11',
      };

      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: [2000, 1414],
        filters: ['ASCIIHexEncode'],
      });

      doc.setProperties({
        title: `Certificado Final`,
        author: 'Klazia Corp',
        creator: 'Klazia Corp',
      });

      const bg =
        student?.school === 'san bartolome'
          ? `/certificado-san-bartolome.webp`
          : student?.school === 'nueva generacion'
            ? '/certificado-nueva-generacion.webp'
            : `/certificado-san-agustin.webp`;

      try {

        doc.addImage(bg, 'WEBP', 0, 0, 1414, 2000);
      } catch (e) {
        try {
          const imgEl = await loadImage(bg);
          doc.addImage(imgEl, 'WEBP', 0, 0, 1414, 2000);
        } catch (err) {
          console.warn('No se pudo cargar la imagen de fondo (viejo):', err);
        }
      }


      doc.setFontSize(31);
      doc.setFont('Helvetica', 'normal');

      doc.text(
        `${student?.user?.first_name?.toUpperCase() || ''} ${student?.user?.last_name?.toUpperCase() || ''}`,
        100,
        495
      );
      doc.text(`${typeDoc || ''}`, 743, 495);
      doc.text(`${formatCurrency(student?.identity)}`, 843, 495);
      doc.text(`${student?.expedition_place || ''}`, 1143, 495);
      doc.text(`${year}`, 345, 530);
      doc.text(`${gradeText} (${gradeNumber[gradeText]}°)`, 510, 530);
      doc.text(
        `${gradeText === 'Decimo' ||
          gradeText === 'Décimo' ||
          gradeText === 'Undécimo' ||
          gradeText === 'Undecimo' ||
          gradeText === 'Once'
          ? 'de Educación Media Secundaria'
          : gradeText === 'Primero' ||
            gradeText === 'Segundo' ||
            gradeText === 'Tercero' ||
            gradeText === 'Cuarto' ||
            gradeText === 'Quinto'
            ? 'de Educación Básica Primaria'
            : 'de Educación Básica Secundaria'
        }`,
        690,
        530
      );

      const init = 775;

      const materiasCertificado = (dataResults || []).filter(
        (el) => !extraNames.has((el?.name || '').replace(/\s\d.*$/, ''))
      );
      materiasCertificado.forEach((el, index) => {
        const textoLimpio = el.name;
        const yOffset = index < 3 ? 40 : index < 5 ? 38 : index < 7 ? 37 : 36;
        const finalNote =
          el?.sitting?.note !== undefined && el?.sitting?.note !== null
            ? Math.max(Math.min(Number(el.sitting.note) / 10, 6.5), Number(el.note) || 0)
            : (Number(el.note) || 0);

        const y = init + yOffset * index;

        doc.text(`${textoLimpio}`, 115, y);
        doc.text(`${el.intensity || ''}`, 640, y);

        const desempeno = finalNote;
        const desempenoTexto =
          desempeno <= 6.4
            ? 'BAJO'
            : desempeno >= 6.5 && desempeno <= 8.4
              ? 'BÁSICO'
              : desempeno >= 8.5 && desempeno <= 9.4
                ? 'ALTO'
                : 'SUPERIOR';

        const notaTexto = finalNote?.toFixed(1).replace('.', ',') || '0,0';
        const resultadoTexto = `${notaTexto} DESEMPEÑO ${desempenoTexto}`;

        doc.text(resultadoTexto, 945, y);
      });

      doc.text(
        `${promovido[gradeText]} ${promovido[gradeText] === 'Graduado' ? '' : `(${Number(gradeNumber[gradeText]) + 1}°)`}`,
        530,
        1460
      );
      doc.text(`${student?.school === 'san bartolome' ? 'Bucaramanga' : 'Floridablanca'}`, 525, 1855);
      doc.text(`${capitalize(dayjs().format('DD'))}`, 780, 1855);
      doc.text(`${capitalize(dayjs().format('MMM'))}`, 1000, 1855);
      doc.text(`${capitalize(dayjs().format('YYYY'))}`, 1100, 1855);


      const pdfBlob = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const newWindow = window.open(pdfUrl, '_blank');
      if (!newWindow) {
        alert('Por favor, habilite los pop-ups para esta página.');
      } else {
        newWindow.focus();
      }

      setTimeout(() => setLoading(false), 100);
    } catch (error) {
      console.error('Error generarCertificadoViejo:', error);
      setLoading(false);
    }
  };

  const generarCertificadoNuevo = async () => {
    if (!student) {
      console.error('No se recibió student');
      return;
    }

    try {
      const sinGrado = grade.replace(/grado:\s*|\s*\(.*?\)/gi, '');
      const soloText = sinGrado.split(' ')[0];
      const sinTildes = soloText.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const gradeText = capitalize(sinTildes);

      const gradeNumber = {
        Primero: '1',
        Segundo: '2',
        Tercero: '3',
        Cuarto: '4',
        Quinto: '5',
        Sexto: '6',
        Séptimo: '7',
        Septimo: '7',
        Octavo: '8',
        Noveno: '9',
        Décimo: '10',
        Decimo: '10',
        Undécimo: '11',
        Once: '11',
        Undecimo: '11',
      };

      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: [2000, 1414],
        filters: ['ASCIIHexEncode'],
      });

      doc.setProperties({
        title: `Certificado Final`,
        author: 'Klazia Corp',
        creator: 'Klazia Corp',
      });

      const schoolName = (student?.school || '').toLowerCase();
      const gradeNum = Number(gradeNumber[gradeText]) || 0;

      const getLevel = (n) => {
        if (n >= 1 && n <= 5) return 'primaria';
        if (n >= 6 && n <= 9) return 'basica';
        if (n >= 10 && n <= 11) return 'media';
        return 'basica';
      };
      const level = getLevel(gradeNum);

      const templateBySchoolAndLevel = () => {
        if (schoolName === 'iberoamericano') return `iberoamericano-${level}.png`;
        if (schoolName === 'inecol') return `inecol-${level}.png`;
        return `generico-${level}.webp`;
      };

      const bgPath = templateBySchoolAndLevel();
      try {
        const img = await loadImage(`/${bgPath}`);
        doc.addImage(img, 'WEBP', 0, 0, 1414, 2000);
      } catch (e) {
        console.warn('No se pudo cargar bg nuevo certificado:', e);
      }

      doc.setFontSize(31);
      doc.setFont('Helvetica', 'normal');

      doc.text(`${capitalize(student?.user?.first_name || '')} ${capitalize(student?.user?.last_name || '')}`, 165, 586);
      doc.text(`${typeDoc || ''}`, 905, 586);
      doc.text(`${formatCurrency(student?.identity)}`, 1060, 586);
      doc.text(`${capitalize(student?.expedition_place || '')}`, 162, 622);
      doc.text(enrollmentStatus === 'no_aprobado' ? 'Reprobó' : 'Aprobó', 550, 622);
      doc.text(`${year}`, 1248, 660);
      doc.text(`${gradeText} (${gradeNumber[gradeText]}°)`, 105, 660);

      const init = 860;
      const initBasicPrimaria = 828;

      const materiasCertificado = (dataResults || []).filter(
        (el) => !extraNames.has((el?.name || '').replace(/\s\d.*$/, ''))
      );
      materiasCertificado.forEach((el, index) => {
        let textoLimpio = el.name;
        const yOffset = index < 3 ? 40 : index < 5 ? 40 : index < 7 ? 39 : 39;

        const finalNote =
          el?.sitting?.note !== undefined && el?.sitting?.note !== null
            ? Math.max(Math.min(Number(el.sitting.note) / 10, 6.5), Number(el.note) || 0)
            : (Number(el.note) || 0);


        doc.setFontSize(31);
        doc.setFont("Helvetica", "normal");

        const esMedia =
          gradeText === 'Decimo' ||
          gradeText === 'Undecimo' ||
          gradeText === 'Once';

        const yBase = esMedia ? init : initBasicPrimaria;
        const y = yBase + yOffset * index;

        doc.text(`${textoLimpio}`, 115, y);
        doc.text(`${el.intensity ? el.intensity : ''}`, 820, y);

        const desempeno = finalNote;
        const desempenoTexto =
          desempeno <= 6.49
            ? 'BAJO'
            : desempeno >= 6.5 && desempeno <= 8.49
              ? 'BÁSICO'
              : desempeno >= 8.5 && desempeno <= 9.49
                ? 'ALTO'
                : 'SUPERIOR';

        const notaTexto = finalNote.toFixed(1).replace('.', ',');
        const resultadoTexto = `${notaTexto} DESEMPEÑO ${desempenoTexto}`;

        doc.text(resultadoTexto, 945, y);
      });



      if (gradeText === 'Decimo' || gradeText === 'Undecimo' || gradeText === 'Once') {
        doc.text('Ciencias Naturales y educacion ambiental', 115, 822);
        doc.text('Comportamiento', 115, 1370);
        doc.text('EXCELENTE', 1060, 1370);
      } else if (
        gradeText === 'Noveno' ||
        gradeText === 'Octavo' ||
        gradeText === 'Septimo' ||
        gradeText === 'Sexto'
      ) {
        doc.text('Comportamiento', 115, 1250);
        doc.text('EXCELENTE', 1060, 1250);
      } else {
        doc.text('Comportamiento', 115, 1210);
        doc.text('EXCELENTE', 1060, 1210);
      }

      doc.text(`${capitalize(dayjs().format('DD'))}`, 760, 1740);
      doc.text(`${capitalize(dayjs().format('MMM'))}`, 1030, 1740);
      doc.text(`${capitalize(dayjs().format('YYYY'))}`, 1202, 1740);

      const pdfBlob = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const newWindow = window.open(pdfUrl, '_blank');
      if (!newWindow) {
        alert('Por favor, habilite los pop-ups para esta página.');
      } else {
        newWindow.focus();
      }

      setTimeout(() => setLoading(false), 100);
    } catch (error) {
      console.error('Error generarCertificadoNuevo:', error);
      setLoading(false);
    }
  };

  const generarCertificado = async () => {
    setLoading(true);

    const school = (student?.school || '').toLowerCase();

    const usaCertificadoNuevo = school === 'iberoamericano' || school === 'inecol';

    if (usaCertificadoNuevo) {
      await generarCertificadoNuevo();
    } else {
      await generarCertificadoViejo();
    }

    setLoading(false);
  };

  return (
    <div>
      <Button
        colorScheme="messenger"
        isDisabled={loading || loadingData}
        isLoading={loading || loadingData}
        size={'sm'}
        marginY={3}
        onClick={() => {
          generarCertificado();
          setLoading(true);
        }}
        className="bg-primary text-white dark:bg-klazia dark:text-black md:!text-sm !text-xs !md:px-3 !md:py-3 !px-2 !py-2 !m-0"
      >
        Descargar Certificado
      </Button>
    </div>
  );
}

export default Boletin;
